import AnamnesiListPage from "./pages/AnamnesiListPage.vue";
import AnamnesiEditPage from "./pages/AnamnesiEditPage.vue";
import AnamnesiViewPage from "./pages/AnamnesiViewPage.vue";

export default {
    AnamnesiListPage,
    AnamnesiEditPage,
    AnamnesiViewPage,
};
